var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineCloudPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.61 20.75c-.41 0-.75-.34-.74-.76 0-.41.34-.74.75-.74h.04c1.14 0 2.23-.42 3.07-1.2 1.55-1.36 1.66-3.3 1.24-4.67-.42-1.37-1.58-2.92-3.61-3.18a.753.753 0 0 1-.65-.62c-.4-2.39-1.69-4.04-3.63-4.64-2.02-.62-4.35-.01-5.81 1.52-1.42 1.49-1.75 3.56-.93 5.85a.75.75 0 1 1-1.41.51c-1.01-2.81-.55-5.5 1.26-7.39 1.85-1.93 4.79-2.7 7.34-1.91 2.33.72 3.98 2.64 4.57 5.3 2.04.46 3.67 2 4.32 4.13.71 2.32.06 4.7-1.67 6.22a6.136 6.136 0 0 1-4.1 1.58h-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52 20.75c-2.88-.2-4.19-2.46-4.19-4.47s1.31-4.26 4.19-4.47c.74-.01 1.47.16 2.11.48.37.19.51.64.33 1.01-.19.37-.64.51-1.01.33-.42-.22-.9-.31-1.36-.32-1.89.14-2.75 1.59-2.75 2.97 0 1.38.86 2.83 2.8 2.97.41.03.72.39.69.8-.04.4-.37.7-.76.7h-.05zM15.15 10.22a.745.745 0 0 1 .34-1.01c.61-.31 1.3-.48 1.98-.49.39.02.76.32.76.74.01.41-.32.76-.74.76-.46.01-.92.12-1.34.33-.1.07-.22.09-.33.09-.27 0-.54-.15-.67-.42zM8.97 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4a.749.749 0 1 1 0 1.5h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.22 22v-4c0-.41.34-.75.75-.75s.75.34.75.75v4a.749.749 0 1 1-1.5 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineCloudPlus);
export default __webpack_public_path__ + "static/media/vuesax-outline-cloud-plus.9b0e9c1aa2ae3224da75fad83a65f12a.svg";
export { ForwardRef as ReactComponent };